import React, { RefObject } from 'react';
import { Form, Input } from 'antd';
import { connect } from 'react-redux';
import { FormInstance } from 'antd/lib/form';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { RootState } from '@share/utils';
import { setGuests, IReviewBookState } from '@store/slices';
import { ILoginState, IMenuState } from '@share/store/slices';
import { IGuestsBooking } from '@common-types';
import { mailFormat } from '@share/utils';
import './style.scss';
import { debounce, isEmpty } from 'lodash';

interface IMapStateToProps {
  reviewBookStore: IReviewBookState;
  menuStore: IMenuState;
  loginStore: ILoginState;
}

interface IMapDispatchToProps {
  setGuests: (guests: IGuestsBooking[]) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, WrappedComponentProps {
  formRef: RefObject<FormInstance>;
  value: string;
  handleEmailFormValidation: (emailForm: boolean) => void
}

interface IState {
  isFormValid: boolean;
}

class ConfirmationEmailComponent extends React.Component<IProps> {

  getIndexMainGuest = () =>
    this.props.reviewBookStore.guests &&
    this.props.reviewBookStore.guests.findIndex((guest) => guest?.isMainGuest === true);

  state: IState = {
    isFormValid: false,
  }

  setEmailAddress = (value: string | null = null) => {
    const indexMainGuest = this.getIndexMainGuest();
    const items = [...this.props.reviewBookStore.guests];

    items[indexMainGuest] = {
      ...items[indexMainGuest],
      email: value as string,
    };
    this.props.setGuests(items);
  };

  validateEmail = (e: { target: HTMLInputElement }) => {
    this.setEmailAddress(e.target.value);
  };

  onFocus = (e: { target: HTMLInputElement }) => {
    this.props.formRef.current?.setFieldsValue({ email: e.target.value });
  };

  componentDidMount(): void {
    this.checkFormValidity();
    this.props.handleEmailFormValidation(this.state.isFormValid);
  }

  componentDidUpdate(prevProps: IProps, prevState: IState) {
    if (this.props.reviewBookStore.errorsField) {
      this.props.formRef.current?.validateFields().then();
    }
    if (prevState.isFormValid !== this.state.isFormValid) {
      this.props.handleEmailFormValidation(this.state.isFormValid);
    }
  }


  checkFormValidity = debounce(() => {
    if (!this.props.formRef.current) return;

    // Get only errors from visible fields (excluding saveCard and country)
    const hasErrors = this.props.formRef.current
      .getFieldsError()
      .some(({ errors }) => errors.length > 0);

    // Get the current field values
    const allFields = this.props.formRef.current.getFieldsValue();

    // Manually exclude saveCard and country from validation
    const filteredFields = Object.keys(allFields)
      .reduce((obj, key) => {
        obj[key] = allFields[key];
        return obj;
      }, {});

    // Check if all visible fields are either user-filled or pre-filled from sessionStorage
    const allFieldsFilled = Object.entries(filteredFields).every(([key, value]) => {
      return value !== undefined && value !== ""; // Ensure the field is filled
    });
    // Update the button state
    this.setState({ isFormValid: !hasErrors && allFieldsFilled });
  }, 500);

  render(): React.ReactNode {
    const { intl, reviewBookStore, loginStore } = this.props;
    const { loadingBooking } = reviewBookStore;
    const { account } = loginStore;

    const generalBorderRadius: any = account?.generalBorderRadius ? account?.generalBorderRadius : null;
    const style = !isEmpty(generalBorderRadius) ? { borderRadius: generalBorderRadius } : {};

    return (
      <div className="confirmation-email">
        <div className="confirmation-email__header">
          <h4 className="confirmation-email__title secondary-font">
            <FormattedMessage id="confirmation.email" />
          </h4>
          <p className="confirmation-email__description">
            <FormattedMessage id="enter.email.address" />
          </p>
        </div>
        <div className="confirmation-email__main-guest-info">
          <Form
            name="confirmation-email-rule"
            className="confirmation-email__rule"
            layout='vertical'
            ref={this.props.formRef}
            onFieldsChange={this.checkFormValidity}
          >
            <Form.Item
              label={<FormattedMessage id="email" />}
              name="email"
              validateTrigger="onBlur"
              rules={[
                {
                  required: true,
                  pattern: new RegExp(mailFormat),
                  message: intl.formatMessage({ id: 'error.message.email.validation' }),
                },
              ]}
            >
              {/* <div className="confirmation-email__name-input-wrapper" style={style}>
                <span className="confirmation-email__input-label">
                  <FormattedMessage id="email" />
                </span>
                <div className="confirmation-email__input"> */}
              <Input
                placeholder={intl.formatMessage({ id: 'email.address' })}
                value={this.props.value}
                maxLength={255}
                onChange={this.validateEmail}
                onFocus={this.onFocus}
                disabled={loadingBooking}
                className='form-control form-control-lg'
              />
              {/* </div>
              </div> */}
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    reviewBookStore: state.reviewBookStore,
    menuStore: state.navigationMenuStore,
    loginStore: state.loginStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = { setGuests };

export const ConfirmationEmail = connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ConfirmationEmailComponent));
